/* ============================================================
   FITNESS OPREMA — theme.js
   Mobile-first, premium UX
   ============================================================ */
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────── */
  const $ = sel => document.querySelector(sel);
  const $$ = sel => document.querySelectorAll(sel);
  const isMobile = () => window.innerWidth <= 768;

  /* ── Sticky Header ────────────────────────────────────── */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Scroll Lock ──────────────────────────────────────── */
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  }

  /* ── Desktop Dropdowns ────────────────────────────────── */
  function closeAllDropdowns() {
    $$('.nav-item--dropdown.open, .nav-item.open').forEach(el => el.classList.remove('open'));
  }

  $$('.nav-item--dropdown').forEach(item => {
    const trigger = item.querySelector('.nav-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = item.classList.contains('open');
      closeAllDropdowns();
      if (!isOpen) item.classList.add('open');
    });
  });

  document.addEventListener('click', e => {
    if (!e.target.closest('.nav-item--dropdown')) closeAllDropdowns();
  });

  /* ── Mobile Menu ──────────────────────────────────────── */
  const mobileNav     = $('.mobile-nav');
  const overlay       = $('.mobile-nav-overlay');
  const menuToggles   = $$('.menu-toggle');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    lockScroll();
    menuToggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    unlockScroll();
    menuToggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
    // Close all accordion items
    $$('.mobile-nav-item.open').forEach(i => i.classList.remove('open'));
  }

  menuToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      mobileNav && mobileNav.classList.contains('open') ? closeMenu() : openMenu();
    });
  });

  if (overlay) overlay.addEventListener('click', closeMenu);

  /* Mobile accordion dropdowns */
  $$('.mobile-nav-dropdown-trigger').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const item = trigger.closest('.mobile-nav-item');
      if (!item) return;
      const isOpen = item.classList.contains('open');
      // Close all others (one open at a time)
      $$('.mobile-nav-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Keyboard ─────────────────────────────────────────── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeMenu();
      closeAllDropdowns();
      closePopup();
    }
  });

  /* ── Scroll Animations ────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const delay = Number(entry.target.dataset.delay) || 0;
        // Reduce animation delay on mobile for snappier feel
        const effectiveDelay = isMobile() ? Math.min(delay, 150) : delay;
        setTimeout(() => entry.target.classList.add('in-view'), effectiveDelay);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

    $$('[data-animate]').forEach((el, i) => {
      if (!el.dataset.delay) el.dataset.delay = String(Math.min(i * 60, 350));
      io.observe(el);
    });
  } else {
    $$('[data-animate]').forEach(el => el.classList.add('in-view'));
  }

  /* ── Exit Intent Popup ────────────────────────────────── */
  const popup = $('.popup-overlay');
  let popupShown = false;

  function showPopup() {
    if (!popup || popupShown) return;
    try { if (sessionStorage.getItem('popup-dismissed')) return; } catch(e) {}
    popupShown = true;
    popup.classList.add('active');
    if (isMobile()) lockScroll();
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('active');
    if (isMobile()) unlockScroll();
    try { sessionStorage.setItem('popup-dismissed', '1'); } catch(e) {}
  }

  if (popup) {
    // Click on backdrop or close button
    popup.addEventListener('click', e => {
      if (e.target === popup || e.target.closest('.popup-close') || e.target.closest('[data-popup-dismiss]')) {
        closePopup();
      }
    });

    // Desktop exit intent
    document.addEventListener('mouseleave', e => {
      if (e.clientY < 5) showPopup();
    });

    // Mobile: delay trigger
    if (isMobile()) {
      setTimeout(showPopup, 45000);
    }
  }

  /* ── Product Gallery ──────────────────────────────────── */
  const mainImg  = $('.gallery-main-img');
  const thumbs   = $$('.gallery-thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.querySelector('img')?.src;
        if (src) {
          mainImg.style.opacity = '0';
          setTimeout(() => { mainImg.src = src; mainImg.style.opacity = '1'; }, 150);
        }
      });
    });
  }

  /* ── Product Tabs ─────────────────────────────────────── */
  $$('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('.product-tabs');
      if (!panel) return;
      panel.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      panel.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      const target = document.getElementById(btn.dataset.tab);
      if (target) target.classList.add('active');
    });
  });

  /* ── Lead Form ────────────────────────────────────────── */
  $$('.lead-form form, .contact-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      const orig = btn.innerHTML;
      btn.innerHTML = '<span class="btn-spinner"></span> Šaljem…';
      btn.disabled = true;
      try {
        const res = await fetch(form.action || '/contact#contact_form', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' },
        });
        if (res.ok) {
          form.innerHTML = `<div style="text-align:center;padding:2.5rem 1rem">
            <div style="width:44px;height:44px;border-radius:50%;background:#F5F3F0;display:flex;align-items:center;justify-content:center;margin:0 auto 1rem;font-size:1.2rem">✓</div>
            <h3 style="font-size:1rem;font-weight:500;margin-bottom:.5rem">Hvala vam!</h3>
            <p style="color:#737068;font-size:.88rem;font-weight:300">Javit ćemo vam se unutar 24 sata radnim danom.</p>
          </div>`;
        } else { throw new Error(); }
      } catch {
        btn.innerHTML = orig;
        btn.disabled = false;
      }
    });
  });

  /* ── Quantity buttons ─────────────────────────────────── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const input = btn.closest('.qty-wrapper')?.querySelector('.qty-input');
    if (!input) return;
    input.value = Math.max(1, (parseInt(input.value) || 1) + (btn.dataset.action === 'plus' ? 1 : -1));
  });

  /* ── Announcement close ───────────────────────────────── */
  document.addEventListener('click', e => {
    if (e.target.closest('.announcement-close')) {
      e.target.closest('.announcement-bar')?.remove();
    }
  });

  /* ── Spinner keyframe ─────────────────────────────────── */
  if (!document.getElementById('fitcro-kf')) {
    const s = document.createElement('style');
    s.id = 'fitcro-kf';
    s.textContent = `
      @keyframes spin { to { transform: rotate(360deg); } }
      .btn-spinner {
        display: inline-block; width: 14px; height: 14px;
        border: 2px solid rgba(255,255,255,.35);
        border-top-color: #fff; border-radius: 50%;
        animation: spin .6s linear infinite;
        vertical-align: middle;
      }
    `;
    document.head.appendChild(s);
  }

  /* ── WhatsApp Dismiss ─────────────────────────────────── */
  const waWrap    = document.getElementById('whatsapp-wrap');
  const waBtn     = document.getElementById('whatsapp-dismiss');

  if (waWrap && waBtn) {
    // Check if previously dismissed (session only — reappears next visit)
    try {
      if (sessionStorage.getItem('wa-dismissed')) {
        waWrap.classList.add('dismissed');
      }
    } catch(e) {}

    waBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      waWrap.classList.add('dismissed');
      try { sessionStorage.setItem('wa-dismissed', '1'); } catch(e) {}
    });
  }


})();
